import { FC, useMemo, useRef } from 'react';
import { useParams } from 'react-router';

import { Button } from 'devextreme-react/button';
import DataGrid, {
  Column,
  ColumnChooser,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  StateStoring,
} from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import { useModal } from 'context/ModalProvider/useModal';
import $createDataSource from 'utils/create-data-souce-instance';

import { CreateContractorPumpPriceModal, DeleteContractorPumpPriceModal, EditContractorPumpPriceModal } from './modals';

export const ContractorPumpPriceScreen: FC = () => {
  let { id } = useParams<{ id: string }>();
  const { showModal } = useModal();

  const refGrid = useRef<DataGrid | null>(null);

  const dateSource = useMemo(() => {
    return $createDataSource(`/v1/ContractorPumpPrice/${id}`, 'id');
  }, []);

  const refresh = () => refGrid.current?.instance.refresh();

  const showModalCreate = () => {
    showModal(<CreateContractorPumpPriceModal contractorId={id} onRefresh={refresh} />);
  };

  const showModalDelete = (id: number) => {
    showModal(<DeleteContractorPumpPriceModal id={id} onRefresh={refresh} />);
  };

  const showModalEdit = (rowId: number) => {
    showModal(<EditContractorPumpPriceModal contractorId={id} onRefresh={refresh} id={rowId} />);
  };

  return (
    <div>
      <AppLayoutTop title=" ">
        <ClaimsProvider claimsBlock={['CanChangePumpPrice']}>
          <Button width={120} text="Создать" type="default" onClick={showModalCreate} />
        </ClaimsProvider>
      </AppLayoutTop>

      <AppCard>
        <DataGrid
          dataSource={dateSource}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
          wordWrapEnabled={true}
        >
          <StateStoring enabled={true} type="localStorage" storageKey="contractorLegalPumpPrice" />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <GroupPanel visible={true} />
          <ColumnChooser enabled={true} />

          <Column dataField="factoryName" caption="Площадка" />
          <Column dataField="objectName" caption="Объект" />
          <Column dataField="dateBegin" caption="Дата начала" dataType="date" />
          <Column dataField="dateEnd" caption="Дата окончания" dataType="date" />
          <Column dataField="pumpLen" caption="Длина стрелы" />
          <Column dataField="minQuantity" caption="Минимальный объем" />
          <Column dataField="pumpPriceMinimal" caption="Минимальная цена" />
          <Column dataField="price" caption="Цена за куб" />

          <Column dataField="pumpInnings" caption="Подача" />
          <Column dataField="pumpQuencher" caption="Гаситель" />
          <Column dataField="downtime" caption="Простой" />
          <Column dataField="pumpMoving" caption="Переезд" />
          <Column dataField="pumpPipes" caption="Трубы" />

          <Column
            dataField=""
            caption=""
            width={150}
            cellRender={(data) => (
              <ClaimsProvider claimsBlock={['CanChangePumpPrice']}>
                <div>
                  <Button icon="edit" type="default" stylingMode="text" onClick={() => showModalEdit(data.data.id)} />
                  <Button
                    icon="trash"
                    type="default"
                    stylingMode="text"
                    onClick={() => showModalDelete(data.data.id)}
                  />
                </div>
              </ClaimsProvider>
            )}
          />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};
